import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import {
  Station,
  StationsState
} from '../../types';

import { binarySearch } from 'common/utils';
import { getFilteredStations } from '../operations/getFilteredStations';

import { STATUS_LOADING } from 'common/constants';

const mappingStationCodes = (stationCodes: Station['code'][], stations: Station[] = []) => stationCodes.reduce((acc, stationCode) => {
  const item = binarySearch<Station>({ key: 'code', value: stationCode }, stations);

  if (item && item.code && item.coordinates) {
    acc.push(item);
  }

  return acc;
}, [] as Station[]);

export const setFilteredStations = (builder: ActionReducerMapBuilder<StationsState>) => builder
  .addCase(getFilteredStations.pending, (state) => {
    state.filteredStations.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getFilteredStations.fulfilled, (state, { payload }) => {
    state.filteredStations.loadingStatus = STATUS_LOADING.done;
    state.filteredStations.data = mappingStationCodes(payload, state.stations.data);
  })
  .addCase(getFilteredStations.rejected, (state) => {
    state.filteredStations.loadingStatus = STATUS_LOADING.error;
  });
